import type { HelpFile } from '../../types/help'
import { ResponseFiltersEditorTestIds } from '../../../testids/ResponseFiltersEditorTestIds'

export const responseFiltersEditorHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [ResponseFiltersEditorTestIds.responseFilters]:
      'Post-Fetch-UND-Filter — Items werden nur behalten, wenn jedes (Feld = Wert)-Paar passt. Jede Zeile ist ein (Feld, Wert)-Paar, das als String gegen den Quellsatz verglichen wird.',
    [ResponseFiltersEditorTestIds.btnAddResponseFilter]:
      'Ein weiteres Feld-Wert-Paar zum Antwortfilter hinzufügen. Alle Paare müssen passen, damit ein Item behalten wird.',
  },
}
